
import { defineComponent, computed } from 'vue'
import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { faSearch, faCodeBranch, faBug, faThLarge, faCog } from '@fortawesome/free-solid-svg-icons'
import { faCopy } from '@fortawesome/free-regular-svg-icons'
import { faGitAlt } from '@fortawesome/free-brands-svg-icons'

export default defineComponent({
  props: {
    isThemeChanged: Boolean,
    isCollapsed: Boolean,
    isOpenExplorer: Boolean
  },
  setup (_, { emit }) {
    const manuIcons = {
      faCopy,
      faSearch,
      faCodeBranch,
      faGitAlt,
      faBug,
      faThLarge
    }

    const icons = computed(() => ({ faCog }))

    const changeTheme = () => emit('change-theme')

    const toggleExplorer = (icon: IconDefinition) => {
      if (icon !== manuIcons.faCopy) {
        return
      }

      emit('toggle-explorer')
    }

    return {
      manuIcons,
      icons,
      changeTheme,
      toggleExplorer
    }
  }
})
